(() => {
  const modules = document.querySelectorAll('[data-exhibition-coverflow]');

  modules.forEach((module) => {
    const stage = module.querySelector('[data-exhibition-stage]');
    const cards = [...module.querySelectorAll('[data-exhibition-card]')];
    const dots = [...module.querySelectorAll('[data-exhibition-dot]')];
    const previousButton = module.querySelector('[data-exhibition-prev]');
    const nextButton = module.querySelector('[data-exhibition-next]');
    const storyLink = module.querySelector('[data-exhibition-story-link]');
    const liveCount = cards.length;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let active = 0;

    if (!stage || !liveCount) return;

    const render = () => {
      cards.forEach((card, index) => {
        const offset = index - active;
        let state = 'far';
        if (offset === 0) state = 'active';
        else if (offset === 1) state = 'previous';
        else if (offset > 1) state = 'far';
        else state = 'next';
        card.dataset.state = state;
        card.setAttribute('aria-hidden', offset === 0 ? 'false' : 'true');
        card.querySelector('a')?.setAttribute('tabindex', offset === 0 ? '0' : '-1');
      });

      dots.forEach((dot, index) => {
        const isLive = index < liveCount;
        dot.disabled = !isLive;
        dot.setAttribute('aria-current', isLive && index === active ? 'true' : 'false');
      });

      if (previousButton) previousButton.disabled = active === 0;
      if (nextButton) nextButton.disabled = active === liveCount - 1;

      const activeLink = cards[active]?.querySelector('a');
      if (storyLink && activeLink) {
        storyLink.href = activeLink.href;
        storyLink.setAttribute('aria-label', activeLink.getAttribute('aria-label') || 'Explore the selected exhibition story');
      }
    };

    const goTo = (index) => {
      active = Math.max(0, Math.min(liveCount - 1, index));
      render();
    };

    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        if (index < liveCount) goTo(index);
      });
    });

    previousButton?.addEventListener('click', () => goTo(active - 1));
    nextButton?.addEventListener('click', () => goTo(active + 1));

    module.addEventListener('click', (event) => {
      const target = event.target instanceof Element ? event.target : null;
      const card = target?.closest('[data-exhibition-card]');
      if (!card || !module.contains(card)) return;

      const index = cards.indexOf(card);
      if (index === -1 || index === active) return;

      event.preventDefault();
      event.stopPropagation();
      goTo(index);
    }, true);

    stage.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        goTo(active - 1);
      }
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        goTo(active + 1);
      }
    });

    stage.addEventListener('dragstart', (event) => event.preventDefault());

    cards.forEach((card) => {
      if (!reducedMotion) {
        card.addEventListener('pointermove', (event) => {
          if (card.dataset.state !== 'active') return;
          const rect = card.getBoundingClientRect();
          const rx = ((event.clientY - rect.top) / rect.height - .5) * -2.2;
          const ry = ((event.clientX - rect.left) / rect.width - .5) * 2.8;
          card.style.setProperty('--tilt-x', `${rx}deg`);
          card.style.setProperty('--tilt-y', `${ry}deg`);
        });
        card.addEventListener('pointerleave', () => {
          card.style.removeProperty('--tilt-x');
          card.style.removeProperty('--tilt-y');
        });
      }
    });

    render();
  });
})();
